import updateCartAttributesMutation from "@graphql/update-cart-attributes.graphql";
import { storefrontAPIFetcher } from "@react/hooks/fetchers";
import { STOREFRONT_API_URL } from "@tablescape/constants";

export const onwardUpdateCartAttributes =
  (cartId: string) => async (attributes: Record<string, string>) => {
    if (!attributes || Object.keys(attributes).length === 0) return;

    const attributesPayload = Object.entries(attributes).map(
      ([key, value]) => ({
        key,
        value: String(value),
      })
    );

    try {
      const response = await storefrontAPIFetcher([
        STOREFRONT_API_URL,
        updateCartAttributesMutation,
        { cartId, attributes: attributesPayload },
      ]);

      const userErrors = response?.cartAttributesUpdate?.userErrors;

      if (userErrors?.length) {
        throw new Error(
          userErrors
            .map(({ message }: { message: string }) => message)
            .join(", ")
        );
      }
    } catch (error) {
      console.error("Error updating cart attributes:", error);
    }
  };
